<template>
    <div v-if="status === 'PENDING'" class="mr-2">
        <font-awesome-icon
            :icon="['fas', 'user-clock']"
            title="Guest verification is in progress"
            :size="size"
            color="#FDCF26"
        />
    </div>
    <div v-else-if="status === 'NOT_VERIFIED'" class="mr-2">
        <font-awesome-icon :icon="['fas', 'user-xmark']" title="Guest is not verified" :size="size" color="#F23434" />
    </div>
    <div v-else-if="status === 'VERIFIED'" class="mr-2">
        <font-awesome-icon :icon="['fas', 'user-check']" title="Guest is verified" :size="size" color="#039356" />
    </div>
    <div v-else-if="status === 'FAILED'" class="mr-2">
        <font-awesome-icon
            :icon="['fas', 'user-slash']"
            title="Guest failed verification"
            :size="size"
            color="#F23434"
        />
    </div>
    <span v-else></span>
</template>

<script>
export default {
    props: {
        status: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'lg',
        },
    },
};
</script>

<style>
</style>